import Icon from '../components/Icon.vue'

Icon.register({
  'wine-bottle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 72.6L439.4 4.7C433.2-1.6 423.1-1.6 416.8 4.7L394.2 27.3C387.9 33.6 387.9 43.7 394.2 49.9L317.5 126.6C270.9 106.9 215.1 115.9 177.1 153.9L18.8 312.2C-6.2 337.2-6.2 377.8 18.8 402.7L109.3 493.3C134.3 518.2 174.8 518.2 199.8 493.3L358.2 334.9C396.1 296.9 405.1 241.1 385.4 194.5L462.1 117.8C468.3 124.1 478.4 124.1 484.7 117.8L507.3 95.2C513.6 88.9 513.6 78.8 507.3 72.6zM179.2 423.3L88.7 332.8 210.8 210.7 301.3 301.3 179.2 423.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wine-bottle.js
// module id = kK7s
// module chunks = 144